import i18n from 'i18n';

const createTranslator =
  (basePath: string) =>
  (key: string): string =>
    i18n.t(`${basePath}.${key}`, { ns: 'transportCloud' });

export const GENERAL = {
  title: i18n.t('form.title', { ns: 'transportCloud' }),
};

const tFormLabels = createTranslator('form.labels');
export const LABELS = {
  date: tFormLabels('date'),
  amount: tFormLabels('amount'),
  customer: tFormLabels('customer'),
  relation: tFormLabels('relation'),
  loadingDeliveryLocation: tFormLabels('loadingDeliveryLocation'),
  truckersRate: tFormLabels('truckersRate'),
  containerNumbers: tFormLabels('containerNumbers'),
  comment: tFormLabels('comment'),
  trucker: tFormLabels('trucker'),
  currency: tFormLabels('currency'),
  shipowner: tFormLabels('shipowner'),
  containerSize: tFormLabels('containerSize'),
};

const tFormButtons = createTranslator('form.buttons');
export const BUTTONS = {
  addEntry: tFormButtons('addEntry'),
  save: tFormButtons('save'),
  cancel: tFormButtons('cancel'),
};

const tFormValidation = createTranslator('form.validation');
export const VALIDATION = {
  fieldRequired: i18n.t('required', { ns: 'validation' }),
  fieldMinZero: i18n.t('min', { ns: 'validation', replace: { '0': '0' } }),
  truckersRate: tFormValidation('truckersRate'),
  currency: tFormValidation('currency'),
  amount: tFormValidation('amount'),
  containerNumbersISO: tFormValidation('containerNumbersISO'),
  containerNumbersAmount: tFormValidation('containerNumbersAmount'),
};

export const MESSAGES = {
  createSuccess: i18n.t('message.createSuccess', { ns: 'misc' }),
  createError: i18n.t('message.generalError', { ns: 'misc' }),
};
